import coreUtils from 'lib/utils-core';
import * as site from 'site/siteUtils';

export default { ...coreUtils, site };